import React from 'react';
import './Foodpackmobi.css';
import fittingImage from '../../../imgs/kfapplicat.webp'; 

const Foodpackmobi = () => {
  return (
    <div className="Foodpack-container" data-aos="fade-down">
      <img src={fittingImage} alt="Fitting Corrosion" className="Foodpack-image" />
    </div>
  );
};

export default Foodpackmobi;
